(function () {
  'use strict';

  var POLL_INTERVAL_MS = 3000;
  var CHECK_TABS = [{ id: 'all', label: 'All' }];

  function apiBase(root) {
    return (root.dataset.apiBase || window.SEO_API_BASE || '').replace(/\/$/, '');
  }

  async function request(root, path, options) {
    options = options || {};
    var response = await fetch(apiBase(root) + path, Object.assign({}, options, {
      headers: Object.assign({
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': 'true'
      }, options.headers || {})
    }));
    var body = await response.json().catch(function () { return {}; });

    if (!response.ok) {
      throw new Error(body.error || ('Request failed (' + response.status + ')'));
    }

    return body;
  }

  function wait(ms) {
    return new Promise(function (resolve) { window.setTimeout(resolve, ms); });
  }

  function text(value, fallback) {
    if (value == null || value === '') return fallback || 'Unavailable';
    if (Array.isArray(value)) return value.map(function (item) { return text(item, ''); }).filter(Boolean).join(', ') || (fallback || 'Unavailable');
    if (typeof value === 'object') {
      try {
        return Object.keys(value).map(function (key) { return key + ': ' + text(value[key], ''); }).join(', ');
      } catch (_error) {
        return fallback || 'Unavailable';
      }
    }
    return String(value);
  }

  function element(tag, className, content) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (content != null) node.textContent = content;
    return node;
  }

  function append(parent) {
    for (var i = 1; i < arguments.length; i += 1) {
      var child = arguments[i];
      if (child != null) parent.appendChild(child);
    }
    return parent;
  }

  function safeHref(value) {
    try {
      var url = new URL(value, window.location.origin);
      return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : '';
    } catch (_error) {
      return '';
    }
  }

  function link(label, href, className) {
    var node = element('a', className, label);
    var safeUrl = safeHref(href);
    if (safeUrl) {
      node.href = safeUrl;
      node.target = '_blank';
      node.rel = 'noopener';
    }
    return node;
  }

  function apiHref(root, path) {
    if (!path) return '';
    if (/^https?:\/\//i.test(String(path))) return safeHref(path);
    return safeHref(apiBase(root) + path);
  }

  function statusStyle(value) {
    var status = String(value || '').toLowerCase();
    if (status.indexOf('pass') !== -1 || status === 'good' || status === 'low') return 'good';
    if (status.indexOf('warning') !== -1 || status.indexOf('unable') !== -1 || status === 'warn' || status === 'medium' || status === 'n/a') return 'warn';
    return 'high';
  }

  function badge(label, status) {
    return element('span', 'wc-seo-results__badge wc-seo-results__badge--' + statusStyle(status || label), text(label));
  }

  function progressMessage(status) {
    return {
      pending: 'Preparing your SEO audit...',
      analyzing: 'Generating your SEO report...',
      teaser_ready: 'SEO report ready'
    }[status] || 'Generating your SEO report...';
  }

  function scoreMetric(label, value) {
    return append(
      element('div', 'wc-seo-results__metric'),
      element('span', '', label),
      element('strong', '', value == null ? 'N/A' : String(value))
    );
  }

  function labelValue(label, value) {
    if (!value) return null;
    var node = element('p');
    append(node, element('strong', '', label + ': '), document.createTextNode(text(value)));
    return node;
  }

  function normalizedCategory(check) {
    return String(check && check.category || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }

  function renderCheckDetails(check) {
    var details = element('div', 'wc-seo-results__tab-finding-details');
    [
      ['Evidence', check.evidence || check.finding],
      ['Impact', check.impact || check.severity || 'Not stated'],
      ['Recommended action', check.recommendation || check.shopify_fix || 'Review this item in your SEO implementation.'],
      ['Method', check.method],
      ['Timestamp', check.timestamp],
      ['Required tool', check.required_tool]
    ].forEach(function (item) {
      if (!item[1]) return;
      details.appendChild(append(
        element('div'),
        element('span', '', item[0]),
        element('p', '', text(item[1]))
      ));
    });
    return details;
  }

  function buildCheckTabs(report) {
    if (report && Array.isArray(report.sections) && report.sections.length) {
      var allChecks = [];
      report.sections.forEach(function (section) {
        allChecks = allChecks.concat(Array.isArray(section.checks) ? section.checks : []);
      });
      return [{
        id: 'all',
        label: 'All',
        summary: report.executive_summary && report.executive_summary.coverage_disclosure ? report.executive_summary.coverage_disclosure : 'Review every SEO check returned by the audit.',
        checks: allChecks
      }].concat(report.sections.map(function (section) {
        return {
          id: section.id,
          label: section.title,
          summary: 'Grade ' + text(section.grade, 'N/A') + ' - ' + text(section.summary, ''),
          checks: Array.isArray(section.checks) ? section.checks : []
        };
      }));
    }
    var checks = Array.isArray(report && report.checks ? report.checks : report) ? (report.checks || report) : [];
    return CHECK_TABS.map(function (tab) {
      var tabChecks = tab.id === 'all'
        ? checks
        : checks.filter(function (check) { return normalizedCategory(check) === tab.id; });
      return {
        id: tab.id,
        label: tab.label,
        summary: tab.id === 'all'
          ? 'Review every SEO check returned by the audit.'
          : 'Focused findings for ' + tab.label + '.',
        checks: tabChecks
      };
    }).filter(function (tab) {
      return tab.id === 'all' || tab.checks.length;
    });
  }

  function renderChecksTabs(parent, report) {
    var entries = buildCheckTabs(report);
    if (!entries.length) return;

    var section = append(
      element('section', 'wc-seo-results__report'),
      element('h2', 'wc-seo-results__section-title', 'SEO checks')
    );
    var tabs = element('div', 'wc-seo-results__tabs');
    var body = element('div', 'wc-seo-results__tab-body');
    var active = 0;

    function show(index) {
      active = index;
      Array.prototype.forEach.call(tabs.querySelectorAll('button'), function (tab, tabIndex) {
        tab.classList.toggle('wc-seo-results__tab--active', tabIndex === active);
        tab.setAttribute('aria-selected', String(tabIndex === active));
      });
      body.replaceChildren();
      var entry = entries[active];
      body.appendChild(append(element('div', 'wc-seo-results__pagewise-head'), element('p', '', entry.summary)));
      if (!entry.checks.length) {
        body.appendChild(element('p', 'wc-seo-results__empty', 'No findings in this area.'));
        return;
      }
      entry.checks.forEach(function (check) {
        body.appendChild(append(
          element('article', 'wc-seo-results__tab-finding'),
          append(
            element('div', 'wc-seo-results__tab-finding-head'),
            element('h3', '', text(check.title || check.category, 'SEO check')),
            badge(String(check.status || 'warning').replace(/_/g, ' '), check.status)
          ),
          renderCheckDetails(check)
        ));
      });
    }

    entries.forEach(function (entry, index) {
      var tab = element('button', 'wc-seo-results__tab', entry.label);
      tab.type = 'button';
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', 'false');
      tab.addEventListener('click', function () { show(index); });
      tabs.appendChild(tab);
    });

    append(section, tabs, body);
    parent.appendChild(section);
    show(active);
  }

  function renderIssueList(parent, items, emptyText) {
    if (!Array.isArray(items) || !items.length) {
      parent.appendChild(element('p', 'wc-seo-results__empty', emptyText || 'No SEO findings are available yet.'));
      return;
    }

    var list = element('div', 'wc-seo-results__issue-list');
    items.forEach(function (item) {
      var issue = append(
        element('article', 'wc-seo-results__issue'),
        append(
          element('div', 'wc-seo-results__issue-head'),
          element('h3', '', text(item.title || item.category, 'SEO finding')),
          badge(item.severity || item.status || 'medium', item.severity || item.status)
        ),
        element('p', '', text(item.finding || item.shopify_fix || item.fix, 'Review this item in the full report.'))
      );
      if (item.fix || item.shopify_fix) {
        issue.appendChild(labelValue('Fix', item.fix || item.shopify_fix));
      }
      list.appendChild(issue);
    });
    parent.appendChild(list);
  }

  function teaserChecks(audit) {
    return audit.teaser && Array.isArray(audit.teaser.checks) ? audit.teaser.checks : [];
  }

  function renderScan(parent, audit) {
    var teaser = audit.teaser || {};
    var scan = element('section', 'wc-seo-results__scan');
    var source = element('p', 'wc-seo-results__source');
    append(source, document.createTextNode('Public SEO scan for '), link(text(audit.storeUrl), audit.storeUrl));
    var head = append(
      element('div', 'wc-seo-results__scan-head'),
      append(element('div'), element('p', 'wc-seo-results__label', 'Live SEO scan'), source),
      append(element('div', 'wc-seo-results__score'), element('p', 'wc-seo-results__label', 'SEO score'), element('strong', '', teaser.score == null ? 'N/A' : teaser.score + '/100'))
    );
    scan.appendChild(head);

    var metrics = element('div', 'wc-seo-results__metrics');
    append(
      metrics,
      scoreMetric('Platform', teaser.platform || (teaser.isShopify ? 'Shopify' : 'Other')),
      scoreMetric('Grade', teaser.grade || 'N/A'),
      scoreMetric('Audit status', audit.status),
      scoreMetric('Priority actions', teaser.priorityActions ? teaser.priorityActions.length : 0)
    );
    scan.appendChild(metrics);
    if (teaser.coverage && teaser.coverage.coverage_percent != null) {
      scan.appendChild(labelValue('Coverage', teaser.coverage.completed + ' of ' + teaser.coverage.total + ' checks completed (' + teaser.coverage.coverage_percent + '%); ' + teaser.coverage.unable + ' require extra tools.'));
    }
    parent.appendChild(scan);
  }

  function renderTeaser(parent, audit) {
    var section = append(element('section', 'wc-seo-results__section'), element('h2', 'wc-seo-results__section-title', 'Top SEO issues found'));
    renderIssueList(section, teaserChecks(audit), 'No SEO teaser findings were returned.');
    parent.appendChild(section);
  }

  function renderUnlockGate(parent, audit, onUnlock, apiRoot) {
    if (audit.unlocked || audit.fullReport) {
      renderFullReport(parent, audit.fullReport, audit.pdfUrl, apiRoot);
      return;
    }

    var section = append(
      element('section', 'wc-seo-results__unlock'),
      element('h2', 'wc-seo-results__section-title', 'Unlock the full SEO report'),
      element('p', '', 'Enter your details to reveal the full SEO report. A Slack notification will be sent after unlock.')
    );
    var form = element('form', 'wc-seo-results__unlock-form');
    var email = element('input');
    email.type = 'email';
    email.name = 'email';
    email.placeholder = 'Work email';
    email.required = true;

    var phone = element('input');
    phone.type = 'tel';
    phone.name = 'phone';
    phone.placeholder = 'Phone number';
    phone.required = true;

    var submit = element('button', 'wc-seo-results__button', 'Unlock full SEO');
    submit.type = 'submit';
    var message = element('p', 'wc-seo-results__unlock-message');

    append(form, email, phone, submit);
    append(section, form, message);
    parent.appendChild(section);

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      submit.disabled = true;
      message.textContent = 'Unlocking your SEO report...';

      try {
        var response = await request(apiRoot, '/api/seo/audits/' + encodeURIComponent(audit.seoAuditId || audit.auditId) + '/unlock', {
          method: 'POST',
          body: JSON.stringify({ email: email.value.trim(), phone: phone.value.trim() })
        });
        if (!response.unlocked) {
          throw new Error('The server did not confirm the SEO report was unlocked.');
        }
        onUnlock(response);
      } catch (error) {
        message.textContent = error.message || 'Unable to unlock the SEO report.';
        submit.disabled = false;
      }
    });
  }

  function renderDownloadButton(parent, pdfUrl, apiRoot) {
    var href = apiHref(apiRoot, pdfUrl);
    if (!href) return;

    var actions = element('div', 'wc-seo-results__actions');
    var download = element('a', 'wc-seo-results__button', 'Download PDF');
    download.href = href;
    download.target = '_blank';
    download.rel = 'noopener';
    download.setAttribute('download', '');
    actions.appendChild(download);
    parent.appendChild(actions);
  }

  function renderList(parent, title, items) {
    if (!Array.isArray(items) || !items.length) return;
    var section = append(element('section', 'wc-seo-results__report'), element('h2', 'wc-seo-results__section-title', title));
    var list = element('ul', 'wc-seo-results__ordered-list');
    items.forEach(function (item) {
      list.appendChild(element('li', '', text(item)));
    });
    section.appendChild(list);
    parent.appendChild(section);
  }

  function renderExecutive(parent, report) {
    var summary = report.executive_summary || {};
    var section = append(element('section', 'wc-seo-results__report'), element('h2', 'wc-seo-results__section-title', 'Executive summary'));
    append(
      section,
      append(
        element('div', 'wc-seo-results__metrics'),
        scoreMetric('Composite grade', summary.composite_grade || report.composite_grade || 'N/A'),
        scoreMetric('Composite score', report.score == null ? 'N/A' : report.score + '/100'),
        scoreMetric('Coverage', report.coverage ? report.coverage.coverage_percent + '%' : 'N/A')
      ),
      element('p', '', text(summary.verdict, 'No executive verdict returned.')),
      element('p', '', text(summary.coverage_disclosure, 'Coverage disclosure unavailable.'))
    );
    parent.appendChild(section);
  }

  function renderPriorityMatrix(parent, matrix) {
    if (!matrix) return;
    var groups = [
      ['Quick wins', matrix.quick_wins],
      ['Strategic fixes', matrix.strategic_fixes],
      ['Fill-in tasks', matrix.fill_in_tasks],
      ['Deprioritize / reconsider', matrix.deprioritize_reconsider]
    ];
    var section = append(element('section', 'wc-seo-results__section wc-seo-results__priority'), element('h2', 'wc-seo-results__section-title', 'Priority matrix'));
    groups.forEach(function (group) {
      var items = Array.isArray(group[1]) ? group[1] : [];
      if (!items.length) return;
      section.appendChild(element('h3', '', group[0]));
      var list = element('ul', 'wc-seo-results__ordered-list');
      items.forEach(function (item) {
        list.appendChild(element('li', '', text(item.finding || item.title) + ' - ' + text(item.recommended_action || item.recommendation)));
      });
      section.appendChild(list);
    });
    parent.appendChild(section);
  }

  function renderFullReport(parent, report, pdfUrl, apiRoot) {
    report = report || {};
    var overview = append(element('section', 'wc-seo-results__report'), element('h2', 'wc-seo-results__section-title', 'Full SEO Report'));
    var metrics = element('div', 'wc-seo-results__metrics');
    append(
      metrics,
      scoreMetric('SEO score', report.score == null ? null : report.score + '/100'),
      scoreMetric('Grade', report.composite_grade || 'N/A'),
      scoreMetric('Platform', report.platform_detection && report.platform_detection.name ? report.platform_detection.name : (report.is_shopify ? 'Shopify' : 'Other')),
      scoreMetric('Checks completed', report.coverage ? report.coverage.completed + '/' + report.coverage.total : 'N/A')
    );
    overview.appendChild(metrics);
    if (report.shopify_detection_method) {
      overview.appendChild(labelValue('Shopify detection', report.shopify_detection_method));
    }
    overview.appendChild(labelValue('Audit timestamp', report.audit_timestamp || report.generated_at));
    if (report.page_scope && report.page_scope.recommended_scope) {
      overview.appendChild(labelValue('Page scope', report.page_scope.recommended_scope));
    }
    parent.appendChild(overview);
    renderDownloadButton(parent, pdfUrl, apiRoot);
    renderExecutive(parent, report);
    renderList(parent, 'Methodology and tool coverage', report.methodology);

    renderChecksTabs(parent, report);
    renderPriorityMatrix(parent, report.priority_matrix);

    if (Array.isArray(report.priority_actions) && report.priority_actions.length) {
      var actions = append(element('section', 'wc-seo-results__section wc-seo-results__priority'), element('h2', 'wc-seo-results__section-title', 'Priority SEO actions'));
      var list = element('ol', 'wc-seo-results__ordered-list');
      report.priority_actions.forEach(function (action) {
        list.appendChild(element('li', '', action));
      });
      actions.appendChild(list);
      parent.appendChild(actions);
    }

    if (Array.isArray(report.shopify_wins) && report.shopify_wins.length) {
      var wins = append(element('section', 'wc-seo-results__report'), element('h2', 'wc-seo-results__section-title', 'Shopify migration wins'));
      var winList = element('ul', 'wc-seo-results__ordered-list');
      report.shopify_wins.forEach(function (win) {
        winList.appendChild(element('li', '', win));
      });
      wins.appendChild(winList);
      parent.appendChild(wins);
    }

    if (Array.isArray(report.migration_cost_of_inaction) && report.migration_cost_of_inaction.length) {
      var costs = append(element('section', 'wc-seo-results__report'), element('h2', 'wc-seo-results__section-title', 'Cost of staying as-is'));
      var costList = element('ul', 'wc-seo-results__ordered-list');
      report.migration_cost_of_inaction.forEach(function (cost) {
        costList.appendChild(element('li', '', cost));
      });
      costs.appendChild(costList);
      parent.appendChild(costs);
    }
  }

  function renderResults(resultsRoot, content, audit) {
    content.innerHTML = '';
    var inner = element('div', 'wc-seo-results__inner');
    append(
      inner,
      append(
        element('div', 'wc-seo-results__hero'),
        element('p', 'wc-seo-results__eyebrow', text(resultsRoot.dataset.eyebrow, 'SEO Audit')),
        element('h1', '', text(resultsRoot.dataset.heading, 'Your SEO report is ready'))
      )
    );

    var back = element('a', 'wc-seo-results__back', text(resultsRoot.dataset.auditAgainLabel, 'Audit another store'));
    back.href = resultsRoot.dataset.auditAgainUrl || window.location.pathname;
    inner.appendChild(back);

    renderScan(inner, audit);
    renderTeaser(inner, audit);
    renderUnlockGate(inner, audit, function (response) {
      audit.unlocked = true;
      audit.fullReport = response.fullReport;
      audit.pdfUrl = response.pdfUrl || audit.pdfUrl;
      renderResults(resultsRoot, content, audit);
    }, resultsRoot);

    content.appendChild(inner);
  }

  async function pollAudit(resultsRoot, auditId, onProgress) {
    var audit;
    do {
      await wait(POLL_INTERVAL_MS);
      audit = await request(resultsRoot, '/api/seo/audits/' + encodeURIComponent(auditId));
      if (audit.status === 'failed') {
        throw new Error(audit.error || 'SEO audit failed.');
      }
      onProgress(progressMessage(audit.status));
    } while (audit.status !== 'teaser_ready');

    return audit;
  }

  function initialize(root) {
    var form = root.querySelector('[data-wc-seo-audit-form]');
    var message = root.querySelector('[data-wc-seo-form-message]');
    var loading = root.querySelector('[data-wc-seo-loading]');
    var loadingMessage = root.querySelector('[data-wc-seo-loading-message]');
    var input = root.querySelector('[data-wc-seo-input]');
    var results = root.querySelector('[data-wc-seo-results]');
    var content = root.querySelector('[data-wc-seo-results-content]');
    if (!form || !results || !content) return;

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      event.stopPropagation();
      var storeUrl = form.elements.store_url.value.trim();
      var submit = form.querySelector('button[type="submit"]');

      message.hidden = true;
      message.textContent = '';
      message.classList.remove('wc-seo__form-message--error');
      loading.hidden = false;
      form.hidden = true;
      results.hidden = true;
      content.innerHTML = '';
      submit.disabled = true;
      loadingMessage.textContent = 'Starting your SEO audit...';

      try {
        var started = await request(root, '/api/seo/audits', {
          method: 'POST',
          body: JSON.stringify({ url: storeUrl })
        });
        var audit = await pollAudit(results, started.seoAuditId || started.auditId, function (copy) {
          loadingMessage.textContent = copy;
        });

        loading.hidden = true;
        input.hidden = true;
        results.hidden = false;
        renderResults(results, content, audit);
      } catch (error) {
        loading.hidden = true;
        form.hidden = false;
        submit.disabled = false;
        message.hidden = false;
        message.textContent = error.message || 'Unable to generate the SEO audit right now.';
        message.classList.add('wc-seo__form-message--error');
      }
    });
  }

  document.querySelectorAll('[data-wc-seo-audit]').forEach(initialize);
})();
